import { AppSku, AppSpecialization } from "./appSku";
import { SectorType } from "../sector/sector.model";
/*
    Apps an organization may discover through a locked preview while it is NOT subscribed to them.
    Mirrors CrossSaleOpportunityApp on the API side, which re-validates every key server-side.

    This is a discovery allowlist, never a subscription list: subscriptions stay exclusively in
    `organizationApps`, and nothing here grants access to an app.

    `sectorType` is set for the `reservations` flavours: their installations are identified by the
    sector they are configured with, because some org apps point at the Spa marketplace app regardless
    of their sector.
 */
export var CrossSaleAppKey = {
    CRM: 'CRM',
    MARKETING: 'MARKETING',
    SURVEYS: 'SURVEYS',
    SPA: 'SPA',
    RESTAURANT: 'RESTAURANT',
    WEEKLY_PLANNER: 'WEEKLY_PLANNER',
    VOICE_NOTE: 'VOICE_NOTE',
    BOOKING_ENGINE: 'BOOKING_ENGINE',
};
/*
    Listed in the order the locked apps are shown (sidebar and My Apps), top to bottom. Subscribed apps
    keep their own ordering; this list never touches it.
 */
export var CROSS_SALE_OPPORTUNITY_APPS = [
    {
        key: CrossSaleAppKey.RESTAURANT,
        slug: 'restaurant',
        sku: AppSku.RESERVATIONS,
        specialization: AppSpecialization.RESTAURANT,
        sectorType: SectorType.RESTAURANT,
        displayName: 'Restaurant',
    },
    {
        key: CrossSaleAppKey.SPA,
        slug: 'spa',
        sku: AppSku.RESERVATIONS,
        specialization: AppSpecialization.SPA,
        sectorType: SectorType.SPA,
        displayName: 'Spa & Beauty',
    },
    { key: CrossSaleAppKey.BOOKING_ENGINE, slug: 'booking-engine', sku: AppSku.BOOKING_ENGINE, displayName: 'Booking Engine' },
    { key: CrossSaleAppKey.SURVEYS, slug: 'surveys', sku: AppSku.SURVEYS, displayName: 'Surveys' },
    { key: CrossSaleAppKey.CRM, slug: 'crm', sku: AppSku.CRM, displayName: 'CRM' },
    { key: CrossSaleAppKey.MARKETING, slug: 'marketing', sku: AppSku.MARKETING, displayName: 'Marketing & Campaigns' },
    {
        key: CrossSaleAppKey.WEEKLY_PLANNER,
        slug: 'weekly-planner',
        sku: AppSku.RESERVATIONS,
        specialization: AppSpecialization.WEEKLY_PLANNER,
        sectorType: SectorType.WEEKLY_PLANNER,
        displayName: 'Weekly Planner',
    },
    { key: CrossSaleAppKey.VOICE_NOTE, slug: 'voice-note', sku: AppSku.VOICE_NOTE, displayName: 'Voice Note' },
];
export var findCrossSaleOpportunityBySlug = function (slug) { return (CROSS_SALE_OPPORTUNITY_APPS.find(function (opportunity) { return opportunity.slug === slug; })); };
export var buildCrossSalePreviewLink = function (opportunity) { return "/preview/".concat(opportunity.slug); };
export var CrossSaleInterestStatus;
(function (CrossSaleInterestStatus) {
    CrossSaleInterestStatus["SENT"] = "SENT";
    CrossSaleInterestStatus["ALREADY_SENT"] = "ALREADY_SENT";
})(CrossSaleInterestStatus || (CrossSaleInterestStatus = {}));
